import { createStore, Store } from "easy-peasy";
import StoreModel from "./reducers";

const store: Store = createStore(StoreModel);

export default store;
